import { BOOKING_URL } from "./booking";

interface BookCallLinkProps {
  /** `light` for light backgrounds (home form), `dark` for the ink use-case form. */
  tone: "light" | "dark";
}

/** Secondary conversion path shown under each lead form. */
export const BookCallLink = ({ tone }: BookCallLinkProps) => (
  <p
    className={`text-sm mt-6 ${tone === "dark" ? "text-white/60" : "text-fwd-ink/55"}`}
  >
    Rather talk it through?{" "}
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`font-semibold underline underline-offset-2 transition-colors ${
        tone === "dark"
          ? "text-white decoration-white/40 hover:decoration-white"
          : "text-fwd-ink decoration-fwd-ink/30 hover:decoration-fwd-ink"
      }`}
    >
      Book a 15-min call
    </a>
  </p>
);
